const MS_PER_SECOND = 1000

export const getCurrentTimeInSeconds = () => Math.floor(new Date().getTime() / MS_PER_SECOND)
